import * as React from 'react';
import { DlqIgnoreRules as DlqIgnoreRulesFactory, Userinfo } from '../tabs';
import { Tabs } from './tabs';
import { Header } from './header';
const DlqIgnoreRules = DlqIgnoreRulesFactory('IGNORE');
const DlqTrashRules = DlqIgnoreRulesFactory('TRASH');
export const Landing = () => (React.createElement(React.Fragment, null,
    React.createElement(Header, null),
    React.createElement(Tabs, { initial: "DlqIgnoreRules", tabs: ['DlqIgnoreRules', 'DlqTrashRules', 'Userinfo'], renderers: { DlqIgnoreRules, DlqTrashRules, Userinfo } })));
//# sourceMappingURL=landing.js.map